import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useSWR from 'swr';
import { OutpostAttempt } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { capitalizeFirstLetter } from '../../../../utils';
import Badge from '../../../common/base/Badge';
import Button from '../../../common/base/Button';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { StyledViewNavHeader, StyledViewNavSecondary, StyledViewSidebar, StyledViewSidebarActions, StyledViewSidebarFooter, StyledViewSidebarNav, StyledViewSidebarScrollableSection, ViewSidebarTitle } from '../../../layouts/ViewLayout';
import { OutpostDataCollapsibleSection } from '../Event/OutpostDataSection';
import { OutpostMetadataCollapsibleSection } from '../Event/OutpostMetadataSection';
import AttemptDetails from './AttemptDetails';
import { OUTPOST_ATTEMPT_INCLUDES } from './utils';
const AttemptSidebar: React.FC<{
  attempt_id: string;
  list_attempt?: OutpostAttempt;
  onClose: () => void;
  onPrev?: () => void;
  onNext?: () => void;
  onRetryAttempt?: (attempt: OutpostAttempt) => void;
  retrying_attempt_id?: string;
}> = t0 => {
  const $ = _c(74);
  const {
    attempt_id,
    list_attempt,
    onClose,
    onPrev,
    onNext,
    onRetryAttempt,
    retrying_attempt_id
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    pathname
  } = useLocation();
  const [active_tab, setActiveTab] = useLocalStorage("prefs:outpost:attempt:active-tab", "details");
  let t1;
  if ($[0] !== attempt_id) {
    t1 = APIMethodKeys.outpost.attempts.get(attempt_id, {
      include: OUTPOST_ATTEMPT_INCLUDES
    });
    $[0] = attempt_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.outpost.attempts || $[3] !== attempt_id) {
    t2 = () => HookdeckAPI.outpost.attempts.get(attempt_id, {
      include: OUTPOST_ATTEMPT_INCLUDES
    });
    $[2] = HookdeckAPI.outpost.attempts;
    $[3] = attempt_id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: fetched_attempt
  } = useSWR(t1, t2);
  const attempt = fetched_attempt || list_attempt;
  let t3;
  let t4;
  if ($[5] !== onClose || $[6] !== onNext || $[7] !== onPrev) {
    t3 = () => {
      const handle_keydown = event => {
        if (event.key === "ArrowUp" && onPrev) {
          event.preventDefault();
          onPrev();
        } else {
          if (event.key === "ArrowDown" && onNext) {
            event.preventDefault();
            onNext();
          } else {
            if (event.key === "Escape") {
              event.preventDefault();
              onClose();
            }
          }
        }
      };
      window.addEventListener("keydown", handle_keydown);
      return () => {
        window.removeEventListener("keydown", handle_keydown);
      };
    };
    t4 = [onPrev, onNext, onClose];
    $[5] = onClose;
    $[6] = onNext;
    $[7] = onPrev;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      align: "center",
      gap: 2
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== attempt_id) {
    t6 = <ViewSidebarTitle title={attempt_id} />;
    $[11] = attempt_id;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== attempt) {
    t7 = attempt && <Badge subtle={true} success={attempt.status === "success"} danger={attempt.status === "failed"}>{capitalizeFirstLetter(attempt.status)}</Badge>;
    $[13] = attempt;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Div flex={t5}>{t6}{t7}</Div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== attempt || $[19] !== onRetryAttempt || $[20] !== retrying_attempt_id) {
    t9 = attempt && onRetryAttempt && <Button.Permission role="member" ghost={true} icon={retrying_attempt_id === attempt.id ? "loading" : "retry"} disabled={retrying_attempt_id === attempt.id} onClick={() => {
      onRetryAttempt(attempt);
    }} />;
    $[18] = attempt;
    $[19] = onRetryAttempt;
    $[20] = retrying_attempt_id;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== attempt_id || $[23] !== pathname) {
    t10 = !pathname.includes(`/deliveries/${attempt_id}`) && <Button ghost={true} icon="open" to={`/deliveries/${attempt_id}`} />;
    $[22] = attempt_id;
    $[23] = pathname;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== onClose) {
    t11 = <Button ghost={true} icon="close" onClick={onClose} />;
    $[25] = onClose;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t9) {
    t12 = <StyledViewSidebarActions>{t9}{t10}{t11}</StyledViewSidebarActions>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t8) {
    t13 = <StyledViewNavHeader>{t8}{t12}</StyledViewNavHeader>;
    $[31] = t12;
    $[32] = t8;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const nav_header = t13;
  if (!attempt) {
    let t14;
    if ($[34] !== nav_header) {
      t14 = <StyledViewSidebarNav>{nav_header}</StyledViewSidebarNav>;
      $[34] = nav_header;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    let t15;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <Div flex={{
        grow: true,
        align: "center",
        justify: "center"
      }}><Loading /></Div>;
      $[36] = t15;
    } else {
      t15 = $[36];
    }
    let t16;
    if ($[37] !== t14) {
      t16 = <StyledViewSidebar>{t14}{t15}</StyledViewSidebar>;
      $[37] = t14;
      $[38] = t16;
    } else {
      t16 = $[38];
    }
    return t16;
  }
  let t14;
  if ($[39] !== attempt.event) {
    t14 = attempt.event?.metadata ? Object.fromEntries(Object.entries(attempt.event.metadata).map(_temp)) : {};
    $[39] = attempt.event;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const metadata_as_strings = t14;
  let t15;
  if ($[41] !== metadata_as_strings) {
    t15 = Object.keys(metadata_as_strings);
    $[41] = metadata_as_strings;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const has_metadata = t15.length > 0;
  let t16;
  if ($[43] !== setActiveTab) {
    t16 = tab => setActiveTab(tab);
    $[43] = setActiveTab;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = [{
      key: "request",
      label: "Request"
    }, {
      key: "response",
      label: "Response"
    }, {
      key: "details",
      label: "Details"
    }];
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== active_tab || $[47] !== t16) {
    t18 = <StyledViewNavSecondary><Tabs active_tab={active_tab} border={false} onTabSelected={t16} tabs={t17} /></StyledViewNavSecondary>;
    $[46] = active_tab;
    $[47] = t16;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== nav_header || $[50] !== t18) {
    t19 = <StyledViewSidebarNav>{nav_header}{t18}</StyledViewSidebarNav>;
    $[49] = nav_header;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== active_tab || $[53] !== attempt) {
    t20 = active_tab === "details" && <Div p={{
      x: 6,
      b: 8
    }}><AttemptDetails attempt={attempt} embedded={true} /></Div>;
    $[52] = active_tab;
    $[53] = attempt;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== active_tab || $[56] !== attempt.event || $[57] !== has_metadata || $[58] !== metadata_as_strings) {
    t21 = active_tab === "request" && <Div>{has_metadata && <OutpostMetadataCollapsibleSection metadata={metadata_as_strings} embedded={true} context_menu={true} context_menu_config={{
        table_column_prefix: "metadata"
      }} />}{attempt.event?.data ? <OutpostDataCollapsibleSection data={attempt.event.data} embedded={true} collapsible={has_metadata} default_collapsed={false} collapsed_storage_key="prefs:outpost:attempt-sidebar:data:collapsed" context_menu={true} context_menu_config={{
        table_column_prefix: "data"
      }} /> : <Div p={{
        x: 6,
        y: 4
      }}><Text muted={true}>No event data available for this attempt.</Text></Div>}</Div>;
    $[55] = active_tab;
    $[56] = attempt.event;
    $[57] = has_metadata;
    $[58] = metadata_as_strings;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== active_tab || $[61] !== attempt.response_data) {
    t22 = active_tab === "response" && <Div>{attempt.response_data ? <OutpostDataCollapsibleSection data={attempt.response_data} embedded={true} collapsible={false} /> : <Div p={{
        x: 6,
        y: 4
      }}><Text muted={true}>No response data available for this attempt.</Text></Div>}</Div>;
    $[60] = active_tab;
    $[61] = attempt.response_data;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  let t23;
  if ($[63] !== t20 || $[64] !== t21 || $[65] !== t22) {
    t23 = <StyledViewSidebarScrollableSection>{t20}{t21}{t22}</StyledViewSidebarScrollableSection>;
    $[63] = t20;
    $[64] = t21;
    $[65] = t22;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  let t24;
  if ($[67] !== onNext || $[68] !== onPrev) {
    t24 = (onPrev || onNext) && <StyledViewSidebarFooter><Div w={100} flex={{
        align: "center",
        gap: 2,
        justify: "flex-end"
      }}><Button outline={true} icon="chevron_up" onClick={onPrev} /><Button outline={true} icon="chevron_down" onClick={onNext} /></Div></StyledViewSidebarFooter>;
    $[67] = onNext;
    $[68] = onPrev;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== t19 || $[71] !== t23 || $[72] !== t24) {
    t25 = <StyledViewSidebar>{t19}{t23}{t24}</StyledViewSidebar>;
    $[70] = t19;
    $[71] = t23;
    $[72] = t24;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  return t25;
};
export default AttemptSidebar;
function _temp(t0) {
  const [key, value] = t0;
  return [key, typeof value === "object" ? JSON.stringify(value) : String(value ?? "")];
}